const workTimeType = [
    "Jornada completa",
    "Medio tiempo",
  ];
  
  export default workTimeType;